import {
  A11y,
  Autoplay,
  Controller,
  EffectCards,
  EffectCoverflow,
  EffectCreative,
  EffectCube,
  EffectFade,
  EffectFlip,
  Grid,
  HashNavigation,
  History,
  Keyboard,
  Lazy,
  Manipulation,
  Mousewheel,
  Navigation,
  Pagination,
  Parallax,
  Scrollbar,
  Thumb,
  Virtual,
  Zoom,
  core_default,
  freeMode
} from "./chunk.VVD5NVY2.js";
import "./chunk.I4IFG4JG.js";
export {
  A11y,
  Autoplay,
  Controller,
  EffectCards,
  EffectCoverflow,
  EffectCreative,
  EffectCube,
  EffectFade,
  EffectFlip,
  freeMode as FreeMode,
  Grid,
  HashNavigation,
  History,
  Keyboard,
  Lazy,
  Manipulation,
  Mousewheel,
  Navigation,
  Pagination,
  Parallax,
  Scrollbar,
  core_default as Swiper,
  Thumb as Thumbs,
  Virtual,
  Zoom,
  core_default as default
};
